import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { OnlineOrderStatus } from '../../models/OnlineOrder.model';
import { AppNavigationService } from '../../services/app-navigation.service';
import { AppSettingsService } from '../../services/app-settings.service';
import { CartService } from '../../services/cart.service';
import { LanguageSelectorComponent } from '../language-selector/language-selector';

@Component({
  selector: 'app-app-bar',
  standalone: true,
  imports: [CommonModule, LanguageSelectorComponent, TranslateModule],
  templateUrl: './app-bar.html',
})
export class AppBarComponent {
  public settingsService = inject(AppSettingsService);
  public cartService = inject(CartService);
  public navService = inject(AppNavigationService);

  public canGoBack = this.navService.canGoBack;
  OnlineOrderStatus = OnlineOrderStatus;

  public isCartBumping = signal<boolean>(false);
  private bumpTimeout: any = null;

  constructor() {
    effect(() => {
      const lastAdded = this.cartService.lastAddedItem();
      if (lastAdded) {
        if (this.bumpTimeout) clearTimeout(this.bumpTimeout);
        this.isCartBumping.set(true);
        this.bumpTimeout = setTimeout(() => {
          this.isCartBumping.set(false);
        }, 650);
      }
    });
  }

  activeOrders = this.cartService.activeOrders;
  activeOrderCount = computed(() => this.activeOrders().length);

  topOrderStatus = computed(() => {
    const orders = this.activeOrders();
    if (orders.length === 0) return null;
    if (orders.length === 1) return orders[0].Status;
    if (orders.some((o) => o.Status === OnlineOrderStatus.READY)) return OnlineOrderStatus.READY;
    if (
      orders.some(
        (o) =>
          o.Status === OnlineOrderStatus.PREPARING ||
          o.Status === OnlineOrderStatus.ACCEPTED
      )
    )
      return OnlineOrderStatus.ACCEPTED;
    if (orders.some((o) => o.Status === OnlineOrderStatus.PENDING)) return OnlineOrderStatus.PENDING;
    return orders[0].Status;
  });

  activeOrderStatus = computed(() => this.topOrderStatus());

  onLanguageChange(langId: string) {
    this.settingsService.setActiveMenuLanguage(langId);
  }

  goBack() {
    this.navService.goBack();
  }

  openCart() {
    this.cartService.openCart();
  }

  openTracking() {
    this.cartService.openTracking();
  }
}
